
import Vue from "vue";

export default Vue.extend({
  name: "SeaWall",
  props: {
    zone: Number,
  },
  computed: {
    y: {
      get(): number {
        return 937 - this.zone * 45;
      },
    },
  },
});
